import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle, faWindows } from "@fortawesome/free-brands-svg-icons";
import activeAgingLogo from "../../assets/images/active-aging-logo.png";
import { Box, Container, Paper, CircularProgress, Button } from "@mui/material";
import styles from "./loginStyles";

const LoginPage: React.FC = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const {
    container,
    loginBox,
    logoContainer,
    logo,
    socialMediaButtonsContainer,
    socialMediaButton,
  } = styles;

  useEffect(() => {
    if (!isLoading) {
      setLoading(false);
    }
    if (isAuthenticated) {
      navigate("/participants");
    }
  }, [isAuthenticated, isLoading, navigate]);

  const handleSocialLogin = (provider: string) => {
    loginWithRedirect({
      authorizationParams: {
        connection: provider,
      },
    });
  };

  return (
    <Container maxWidth={false} sx={container}>
      <Paper elevation={3} sx={loginBox}>
        <Box sx={logoContainer}>
          <img src={activeAgingLogo} alt="logo" style={logo} />
        </Box>
        <Box sx={socialMediaButtonsContainer}>
          {loading ? (
            <CircularProgress />
          ) : (
            <>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleSocialLogin("google-oauth2")}
                sx={{ ...socialMediaButton, mb: 2 }}
              >
                <FontAwesomeIcon icon={faGoogle} /> Continue With Google
              </Button>
              <Button
                variant="contained"
                onClick={() => handleSocialLogin("windowslive")}
                sx={{ ...socialMediaButton, backgroundColor: "#2F2F2F" }}
              >
                <FontAwesomeIcon icon={faWindows} /> Continue With Microsoft
              </Button>
            </>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default LoginPage;
